<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M17.612 3.41452C17.1722 2.96607 16.65 2.61034 16.0752 2.36763C15.5005 2.12492 14.8844 2 14.2623 2C13.6401 2 13.0241 2.12492 12.4493 2.36763C11.8746 2.61034 11.3524 2.96607 10.9126 3.41452L9.99977 4.34476L9.08699 3.41452C8.19858 2.50912 6.99364 2.00047 5.73725 2.00047C4.48085 2.00047 3.27591 2.50912 2.38751 3.41452C1.4991 4.31992 1 5.5479 1 6.82833C1 8.10875 1.4991 9.33674 2.38751 10.2421L3.30029 11.1724L9.99977 18L16.6992 11.1724L17.612 10.2421C18.0521 9.79391 18.4011 9.26171 18.6393 8.67596C18.8774 8.0902 19 7.46237 19 6.82833C19 6.19428 18.8774 5.56645 18.6393 4.9807C18.4011 4.39494 18.0521 3.86275 17.612 3.41452V3.41452Z" stroke="#858E97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconFavorites',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
